import React from 'react';
import EstadoAcademicoChip from './EstadoAcademicoChip';
import { formatFechaHora, formatNota, getEvaluacionColumnTitle, isNotaDesaprobada } from '../../utils/evaluaciones';
import './Evaluaciones.css';

// Notas de un alumno en cada instancia, con los comentarios del docente, su promedio y su estado.
const AlumnoNotasDetalle = ({ alumno, evaluaciones = [], onClose }) => {
  const notasPorEvaluacion = new Map((alumno?.notas || []).map((nota) => [nota.idEvaluacion, nota]));

  return (
    <div className="ev-overlay ev-overlay-top" onMouseDown={onClose}>
      <div className="ev-modal ev-modal-small" role="dialog" aria-modal="true" onMouseDown={(event) => event.stopPropagation()}>
        <header className="ev-modal-header">
          <div>
            <span className="ev-eyebrow">Notas del alumno</span>
            <h3>{alumno?.nombre || 'Alumno'}</h3>
          </div>
          <button type="button" className="ev-icon-btn" onClick={onClose} title="Cerrar">
            <i className="fas fa-times" aria-hidden="true" />
          </button>
        </header>
        <div className="ev-modal-body">
          <div className="ev-alumno-summary">
            <EstadoAcademicoChip estado={alumno?.estado} promedio={alumno?.promedio} />
            <span>
              {alumno?.cantidadNotas || 0} {alumno?.cantidadNotas === 1 ? 'nota' : 'notas'}
              {' · '}
              {alumno?.cantidadAusentes || 0} {alumno?.cantidadAusentes === 1 ? 'ausencia' : 'ausencias'}
            </span>
          </div>
          {alumno?.porMateria?.length > 1 && (
            <div className="ev-materias-chips">
              {alumno.porMateria.map((materia) => (
                <span key={materia.idCursoMateria}>
                  {materia.nombreMateria}: <EstadoAcademicoChip estado={materia.estado} promedio={materia.promedio} />
                </span>
              ))}
            </div>
          )}
          {evaluaciones.length === 0 ? (
            <p className="ev-empty">Todavía no hay instancias de evaluación.</p>
          ) : (
            <ul className="ev-notas-list">
              {evaluaciones.map((evaluacion) => {
                const nota = notasPorEvaluacion.get(evaluacion.id);
                return (
                  <li key={evaluacion.id}>
                    <div>
                      <strong>{getEvaluacionColumnTitle(evaluacion)}</strong>
                      <small>{formatFechaHora(evaluacion.fechaHora)}</small>
                      {nota?.comentario && <p><i className="fas fa-comment-dots" aria-hidden="true" /> {nota.comentario}</p>}
                    </div>
                    <span className={`ev-nota-pill${nota?.ausente ? ' ausente' : isNotaDesaprobada(nota?.nota) ? ' baja' : nota?.nota != null ? ' ok' : ''}`}>
                      {nota?.ausente ? 'Ausente' : nota?.nota != null ? formatNota(nota.nota) : 'Sin nota'}
                    </span>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default AlumnoNotasDetalle;
